import { configureRouter, redirectWithSessionStoragePayload, triggerAction, } from "./router";
const benefitsRoute = "/heyobi/customer-center/benefits";
const HEY_OBI_CUSTOM_EVENT_APPOINTMENT_OPEN_EDIT_SIDEBAR = "hey-obi-web:appointment:edit-open";
const HEY_OBI_CUSTOM_EVENT_APPOINTMENT_OPEN_CANCEL_SIDEBAR = "hey-obi-web:appointment:cancel-open";
const EMPTY_PAYLOAD = "EMPTY_PAYLOAD";
const START_RAFFLE = "start";
const CANCEL_RAFFLE = "cancel";
const raffleActionTrigger = (raffleId, entry) => {
    triggerAction("hey-obi-web:raffle-journey:load", {
        journey: "raffle",
        data: {
            id: raffleId,
            entry,
        },
    });
};
const router = configureRouter({
    "/heyobi/inbox/notifications": () => triggerAction("hey-obi-web:open-notification-center-sidebar", {}),
    "/heyobi/call/create-inquiry?subject=Pflegekalender%3A%20Themenauswahl&source=careplan": () => triggerAction("hey-obi-web:advice-journey:open", {
        journey: "advice",
        origin: "care-calendar-topic-selector",
        target: "mailflow",
        configId: "32fa4c89-c93d-4767-9d2a-b4cf5ccccc3b",
    }),
    "/heyobi/raffle/{raffleId}": (options, raffleId) => raffleActionTrigger(raffleId, START_RAFFLE),
    "/heyobi/raffle/{raffleId}/cancel": (options, raffleId) => raffleActionTrigger(raffleId, CANCEL_RAFFLE),
    "/heyobi/care-plan/catalog": () => triggerAction("hey-obi-web:content:care-calendar-topic-selector:load"),
    "/heyobi/care-plan/topic-wish": () => triggerAction("hey-obi-web:content:wish-topic:load"),
    "/heyobi/promotion/activation/form:?query:": (options, query) => redirectWithSessionStoragePayload(benefitsRoute, query?.code || EMPTY_PAYLOAD),
    "/promotion/activation/form:?query:": (options, query) => redirectWithSessionStoragePayload(benefitsRoute, query?.code || EMPTY_PAYLOAD),
    "/heyobi/welcomecoupon": () => triggerAction("hey-obi-web:open-welcome-coupon-sidebar"),
    "obi-companion://internal/context/appointment-defer/{inquiryId}": (options, inquiryId) => {
        triggerAction(HEY_OBI_CUSTOM_EVENT_APPOINTMENT_OPEN_EDIT_SIDEBAR, {
            inquiryId,
        });
    },
    "obi-companion://internal/context/appointment-cancel/{inquiryId}": (options, inquiryId) => {
        triggerAction(HEY_OBI_CUSTOM_EVENT_APPOINTMENT_OPEN_CANCEL_SIDEBAR, {
            inquiryId,
        });
    },
    "obi-companion://internal/context/raffle": () => triggerAction("hey-obi-web:raffle-sidebar:start-click"),
    "obi-companion://raffle/{raffleId}/cancel": (options, raffleId) => raffleActionTrigger(raffleId, CANCEL_RAFFLE),
    "obi-companion://internal/context/youtube-disclaimer": () => triggerAction("hey-obi-web:youtube-embed:show-disclaimer"),
});
const extractPath = (url) => {
    if (url.match(/^\//))
        return url;
    if (url.match(/^http/)) {
        const parsedUrl = new URL(url);
        if (parsedUrl.hostname.match(/www(\.(lab|qa))?\.obi\.(de|at)$/)) {
            return `${parsedUrl.pathname}${parsedUrl.search}`;
        }
    }
    return url;
};
const handleLink = (url, options) => router.parse(extractPath(url), [options]);
export { handleLink };
